import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { PlainAntdIconAsSvg, useA11yId } from "../..";
import { CheckOutlined, MinusOutlined } from "@ant-design/icons-svg";
import { useStylesheet } from "../../contexts";
import { extendCommonStylesheet } from "@devowl-wp/web-cookie-banner";
const Checkbox = (param)=>{
    let { hideCheckbox, isPartial, isChecked, isDisabled, fontSize, onToggle, children, after, ...rest } = param;
    const { checkbox: { className, style }, Label } = useStylesheet().extend(...extendCommonStylesheet);
    const CheckboxIcon = isPartial ? MinusOutlined : CheckOutlined;
    const handleChange = (e)=>{
        const { checked } = e.target;
        onToggle == null ? void 0 : onToggle(checked);
    };
    const a11yId = useA11yId();
    return /*#__PURE__*/ _jsxs(Label, {
        children: [
            !hideCheckbox && /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("input", {
                        name: "checkbox[]",
                        type: "checkbox",
                        value: "1",
                        checked: isChecked,
                        disabled: isDisabled,
                        className: className,
                        style: style({
                            fontSize
                        }),
                        onChange: handleChange,
                        "aria-labelledby": a11yId
                    }),
                    /*#__PURE__*/ _jsx(PlainAntdIconAsSvg, {
                        "aria-hidden": true,
                        icon: CheckboxIcon,
                        ...rest
                    })
                ]
            }),
            children && /*#__PURE__*/ _jsxs("span", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        id: a11yId,
                        "aria-hidden": true,
                        children: children
                    }),
                    after && /*#__PURE__*/ _jsx("span", {
                        onClick: (e)=>{
                            // Do not modify the checkbox
                            e.stopPropagation();
                        },
                        children: after
                    })
                ]
            })
        ]
    });
};
export { Checkbox };
